// Next Diamonds — Desktop filter UX
// 1) Click-to-deselect on filter radios (native browsers don't toggle).
// 2) Defensive "single-active-group" enforcer that fixes a theme-JS bug
//    where all 4 filter groups (Style/Metal/Shape/Price) end up visible
//    on desktop. Root cause: the theme's initializeFilterButtons() captures
//    isMobile = (innerWidth <= 999.98) in a closure at load time. If the
//    viewport is briefly narrow (resize, devtools toggle, narrow first
//    paint), it sets display:block on every filter-group-filter and the
//    desktop setActiveButton early-returns on stale isMobile, never
//    hiding the inactive groups. Inline display:block persists forever
//    after viewport grows.

(function () {
  'use strict';

  function isDesktop() {
    return window.innerWidth >= 1000;
  }

  // ====================================================================
  // SINGLE-ACTIVE-GROUP ENFORCER
  // On desktop, find the active filter button, show only its group, hide
  // the rest. Runs on load, AJAX completion, viewport resize.
  // ====================================================================
  function enforceSingleActiveGroup() {
    if (!isDesktop()) return;

    var groups = document.querySelectorAll('#filters-container .filter-group-filter');
    if (!groups.length) return;

    // Find the active filter button (theme adds .active to it)
    var activeBtn = document.querySelector('#filters-container .filter-button.active');

    // Fallback: use last-saved button from theme localStorage, or first button
    if (!activeBtn) {
      try {
        var savedId = localStorage.getItem('activeFilterButton');
        if (savedId) {
          activeBtn = document.getElementById(savedId);
        }
      } catch (e) {}
    }
    if (!activeBtn) {
      activeBtn = document.querySelector('#filters-container .filter-button');
    }

    if (!activeBtn) return;

    // Mark it active (theme styling)
    document.querySelectorAll('#filters-container .filter-button').forEach(function (btn) {
      btn.classList.remove('active');
    });
    activeBtn.classList.add('active');

    var activeId = activeBtn.id.replace('target-', '');

    // Show only the active group, hide the rest. Use empty string to clear
    // inline display so stylesheet wins where appropriate.
    groups.forEach(function (group) {
      if (group.id === activeId) {
        group.style.display = 'flex';
      } else {
        group.style.display = 'none';
      }
    });
  }

  // Run on first load + a couple safety re-runs while theme JS finishes
  function initEnforcer() {
    enforceSingleActiveGroup();
    setTimeout(enforceSingleActiveGroup, 400);
    setTimeout(enforceSingleActiveGroup, 1200);
    setTimeout(enforceSingleActiveGroup, 2400);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEnforcer);
  } else {
    initEnforcer();
  }

  // Re-enforce after AJAX completes (theme flips .ajax-loading on/off)
  var ajaxContainer = document.querySelector('[data-ajax-container]');
  if (ajaxContainer) {
    var wasLoading = ajaxContainer.classList.contains('ajax-loading');
    var ajaxObs = new MutationObserver(function () {
      var nowLoading = ajaxContainer.classList.contains('ajax-loading');
      if (wasLoading && !nowLoading) {
        setTimeout(enforceSingleActiveGroup, 100);
        setTimeout(enforceSingleActiveGroup, 400);
      }
      wasLoading = nowLoading;
    });
    ajaxObs.observe(ajaxContainer, { attributes: true, attributeFilter: ['class'] });
  }

  // Re-enforce on viewport resize (mobile→desktop transitions are the
  // exact case that triggers the bug)
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(enforceSingleActiveGroup, 180);
  });

  // Also re-enforce when user clicks a filter button (defensive — theme
  // JS already handles this, but redundant safety doesn't hurt)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#filters-container .filter-button');
    if (btn) {
      setTimeout(enforceSingleActiveGroup, 50);
    }
  });

  function recordPreCheck(e) {
    if (!isDesktop()) return;
    if (!e.target.closest) return;
    // Only desktop filter items (not the mobile sheet)
    var item = e.target.closest('#filters-container .filter-group__item');
    if (!item) return;
    var radio = item.querySelector('input[type="radio"]');
    if (!radio) return;
    radio.dataset.ndPreCheck = radio.checked ? '1' : '0';
  }

  function handleClick(e) {
    if (!isDesktop()) return;
    if (!e.target.closest) return;
    var item = e.target.closest('#filters-container .filter-group__item');
    if (!item) return;
    var radio = item.querySelector('input[type="radio"]');
    if (!radio) return;

    // Defer to next tick so the browser's default click toggle finishes first
    setTimeout(function () {
      var was = radio.dataset.ndPreCheck;
      delete radio.dataset.ndPreCheck;
      if (was === '1' && radio.checked) {
        // Was already checked → toggle off + notify theme to re-run AJAX
        radio.checked = false;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 10);
  }

  document.addEventListener('mousedown', recordPreCheck, true);
  document.addEventListener('touchstart', recordPreCheck, true);
  document.addEventListener('click', handleClick);
})();
